import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ValidatorService } from '../../core/services/validator.service';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-existing-customer-toggle',
  templateUrl: './existing-customer-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['existing-customer-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExistingCustomerToggleComponent),
      multi: true,
    },
  ],
})
export class ExistingCustomerToggleComponent implements ControlValueAccessor {
  @Input()
  public validateForm: boolean = false;

  public formControl = new FormControl<boolean | null>(null, Validators.required);

  constructor(public validatorService: ValidatorService) {}

  public registerOnChange(fn: (value: boolean | null) => void): void {
    this.formControl.valueChanges.pipe(untilDestroyed(this)).subscribe(fn);
  }

  public registerOnTouched(fn: () => void): void {
    this.formControl.valueChanges.pipe(untilDestroyed(this)).subscribe(fn);
  }

  public writeValue(value: boolean): void {
    this.formControl.setValue(value);
  }
}
